import React from 'react';
import { Button, Dropdown, Header } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import { ComandoEliminarGastoDiario } from '../tipos';
import ModalBase from './ModalBase';

interface Props {
    idGastoDiario: string;
    alModificarGastos(): void;
}

const enum Estado {
    Cerrado,
    EnEspera,
    Trabajando,
    Error,
}

interface State {
    estado: Estado;
    error: string;
}

class EliminarGastoDiario extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        estado: Estado.Cerrado,
        error: '',
    };

    public render() {
        const { estado } = this.state;

        switch (estado) {
            default:
                return (
                    <Dropdown.Item
                        text={<span style={{ color: 'red' }}>Eliminar gasto</span>}
                        onClick={this.abrirModal}
                    />
                );

            case Estado.EnEspera:
                return (
                    <ModalBase
                        cabecera={`¿Desea eliminar el gasto?`}
                        iconoCabecera='delete'
                        acciones={[
                            <Button
                                key='cancelar'
                                basic
                                content='Cancelar'
                                onClick={this.cerrarModal}
                            />,
                            <Button
                                key='confirmar'
                                negative
                                content='Eliminar para siempre'
                                onClick={this.eliminarGastoDiario}
                            />,
                        ]}
                    >
                        <Header as='h4'>Esta acción no se puede deshacer</Header>

                        <p>Se eliminará el gasto y su información no se podrá recuperar.</p>
                    </ModalBase>
                );

            case Estado.Error:
                return (
                    <ModalBase
                        cabecera='Ocurrió un error'
                        iconoCabecera='exclamation triangle'
                        contenido='No se pudo eliminar el gasto solicitado. Por favor inténtelo
                        nuevamente'
                        acciones={<Button content='Entendido' onClick={this.cerrarModal} />}
                    />
                );

            case Estado.Trabajando:
                return <ModalBase cargando />;
        }
    }

    private readonly eliminarGastoDiario = async () => {
        const { idGastoDiario, alModificarGastos } = this.props;

        this.setState({ estado: Estado.Trabajando });

        const comando: ComandoEliminarGastoDiario = {
            idGastoDiario,
        };

        try {
            await clienteApi.ejecutar('eliminarGastoDiario', comando);
            alModificarGastos();
            this.setState({ estado: Estado.Cerrado });
        } catch (error) {
            this.context.mostrarModalError(error);
            this.setState({ estado: Estado.Error });
        }
    };

    private readonly abrirModal = () => {
        this.setState({ estado: Estado.EnEspera });
    };

    private readonly cerrarModal = () => {
        this.setState(prevState => {
            if (prevState.estado !== Estado.Trabajando) {
                return { estado: Estado.Cerrado };
            }
            return { estado: prevState.estado };
        });
    };
}

export default EliminarGastoDiario;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Gastos/componentes/EliminarGastoDiario.tsx